import { EvidenceQuotaBadge } from '@/components/chat/components/EvidenceQuotaBadge';
import { TypographyFootNote } from '@heidi/design-system/typography';
import { useEvidenceInSessionLimits } from '@/hooks/useEvidenceInSessionLimits';
import { cn } from '@/lib/cn';
import { useTranslations } from '@heidi/runtime/i18n';

export interface ChatInputFooterProps {
  isSessionless: boolean;
  className?: string;
}

/**
 * Footer for the chat input — centered medical-knowledge disclaimer with an optional
 * "{count} left" quota badge in a trailing column (Figma: Trials & upgrades 10492:58270).
 */
export const ChatInputFooter = ({
  isSessionless,
  className,
}: ChatInputFooterProps) => {
  const { t } = useTranslations();
  const { showsQuotaBadge, showsQuotaBadgeSessionless } = useEvidenceInSessionLimits();

  const showQuotaBadge = isSessionless ? showsQuotaBadgeSessionless : showsQuotaBadge;

  return (
    <div
      className={cn(
        'mt-2 mb-2 flex min-h-[22px] items-center',
        showQuotaBadge ? 'justify-between gap-4' : 'justify-center',
        className
      )}
    >
      <TypographyFootNote
        data-testid="evidence-disclaimer"
        className={cn(
          'text-text-tertiary',
          showQuotaBadge ? 'min-w-0 flex-1 text-start pl-1' : 'text-center'
        )}
      >
        {t('askAI.inputDisclaimer')}
      </TypographyFootNote>
      {showQuotaBadge && (
        <div className="flex shrink-0 items-center justify-end">
          <EvidenceQuotaBadge />
        </div>
      )}
    </div>
  );
};
